export enum SSOStatus {
  None = 0,
  Not_Loaded = 1 << 0,
  Loading = 1 << 1,
  Loaded = 1 << 2,
  Load_Failed = 1 << 3,
  Not_Saved = 1 << 4,
  Saving = 1 << 5,
  Saved = 1 << 6,
  Save_Failed = 1 << 7,
  Download_Metadata = 1 << 8,
}
